export default __webpack_public_path__ + "static/media/franchise_managemnt_orange.b2d67d63.svg";